import * as Sentry from "@sentry/react";

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  // Bruk MODE-streng-sammenligning fordi Vite + Vercel-build har vist seg å
  // feilevaluere import.meta.env.PROD / DEV til feil verdier i prod-build
  // (PROD:!1 og DEV=true i bundle selv om `vite build` rapporterer "production").
  const isProd = import.meta.env.MODE === "production";

  if (!dsn) {
    if (isProd) {
      console.warn(
        "[sentry] VITE_SENTRY_DSN not set in production — error tracking disabled",
      );
    }
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA ?? "dev",
    sendDefaultPii: true,
    enableLogs: true,
    tracesSampleRate: isProd ? 0.1 : 1.0,
    replaysSessionSampleRate: isProd ? 0.1 : 0,
    replaysOnErrorSampleRate: isProd ? 1.0 : 0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    beforeSend(event) {
      // Drop dev events
      if (!isProd) return null;
      return event;
    },
  });
}

export { Sentry };
